class CartDrawer extends HTMLElement {
  constructor() {
    super();
      document.addEventListener('shopify:section:select', (event) => {
        if(event && event.detail && event.detail.sectionId === `${this.dataset.section}`) {
          document.body.classList.add("cartdrawer-active");
          document.querySelector('cart-drawer')?.classList.add('animate', 'active');
        }
      });
      
      document.addEventListener('shopify:section:deselect', (event) => {
        if(event && event.detail && event.detail.sectionId === `${this.dataset.section}`) {
          document.body.classList.remove("cartdrawer-active");
          document.querySelector('cart-drawer')?.classList.remove('animate', 'active');
        }
      });

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    const overlay = this.querySelector('#CartDrawer-Overlay');
    if (overlay) overlay.addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();

  }
  
  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-drawer-button');
    if (cartLink) {
      cartLink.setAttribute('role', 'button');
      cartLink.setAttribute('aria-haspopup', 'dialog');
      cartLink.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(cartLink);
      });
      cartLink.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(cartLink);
        }
      });
    }

    // Delegated click handler on document to ensure dynamically rendered or bubbling clicks on cart drawer button always open drawer
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('#cart-drawer-button');
      if (trigger) {
        event.preventDefault();
        this.open(trigger);
      }
    });
  }

  open(triggeredBy, skipRefresh = false) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);

    // Refresh cart drawer with latest cart contents to prevent stale/missing items
    if (!skipRefresh) {
      this.refreshCart();
    }

    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : this.querySelector('.drawer__inner');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        if (containerToTrapFocusOn && focusElement) {
          trapFocus(containerToTrapFocusOn, focusElement);
        }
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden', 'cartdrawer-active');
  }

  refreshCart() {
    fetch(`/?sections=cart-drawer,cart-icon-bubble&_t=${Date.now()}`)
      .then((response) => response.json())
      .then((data) => {
        if (!data || !data['cart-drawer']) return;
        const parsed = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
        const newInner = parsed.querySelector('#CartDrawer');
        const curInner = this.querySelector('#CartDrawer') || document.querySelector('#CartDrawer');
        if (newInner && curInner) {
          curInner.innerHTML = newInner.innerHTML;
        }

        const isNowEmpty = parsed.querySelector('cart-drawer')?.classList.contains('is-empty');
        this.classList.toggle('is-empty', !!isNowEmpty);
        const drawerInner = this.querySelector('.drawer__inner');
        if (drawerInner) drawerInner.classList.toggle('is-empty', !!isNowEmpty);
        const drawerItems = this.querySelector('cart-drawer-items');
        if (drawerItems) drawerItems.classList.toggle('is-empty', !!isNowEmpty);

        if (data['cart-icon-bubble']) {
          const parsedBubble = new DOMParser().parseFromString(data['cart-icon-bubble'], 'text/html');
          const newBubble = parsedBubble.querySelector('#cart-icon-bubble');
          if (newBubble) {
            document.querySelectorAll('#cart-icon-bubble').forEach((el) => {
              el.innerHTML = newBubble.innerHTML;
            });
          }
        }

        const overlay = this.querySelector('#CartDrawer-Overlay');
        if (overlay) overlay.addEventListener('click', this.close.bind(this));
      })
      .catch((err) => {
        console.error('Error refreshing cart drawer:', err);
      });
  }

  close() {
    this.classList.remove('active');
    if(!this.classList.contains('is-empty')){
      this.querySelector('cart-note')?.classList.remove('active');
      document.querySelector('cart-drawer-items')?.classList.remove('active-note');
      document.querySelector('.cart-drawer__footer')?.classList.remove('active-note');
    }
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    document.body.classList.remove("cartdrawer-active");
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling && cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.classList.remove('is-empty');
    const drawerInner = this.querySelector('.drawer__inner');
    if (drawerInner) drawerInner.classList.remove('is-empty');
    const drawerItems = this.querySelector('cart-drawer-items');
    if (drawerItems) drawerItems.classList.remove('is-empty');
    const drawerEmpty = this.querySelector('.drawer__inner-empty');
    if (drawerEmpty) drawerEmpty.remove();

    this.productId = parsedState.id;

    if (parsedState.sections && parsedState.sections['cart-drawer']) {
      this.getSectionsToRender().forEach((section) => {
        const sectionElement = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);
        if (sectionElement && parsedState.sections[section.id]) {
          sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        }
      });

      if (parsedState.sections['cart-icon-bubble']) {
        const parsedBubble = new DOMParser().parseFromString(parsedState.sections['cart-icon-bubble'], 'text/html');
        const newBubble = parsedBubble.querySelector('#cart-icon-bubble');
        if (newBubble) {
          document.querySelectorAll('#cart-icon-bubble').forEach((el) => {
            el.innerHTML = newBubble.innerHTML;
          });
        }
      }
    } else {
      this.refreshCart();
    }

    setTimeout(() => {
      const overlay = this.querySelector('#CartDrawer-Overlay');
      if (overlay) overlay.addEventListener('click', this.close.bind(this));
      this.open(false, true);
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const el = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return el ? el.innerHTML : '';
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
        selector: '#cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '#cart-icon-bubble',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
